/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Legacy_Market } from '../models/Legacy_Market';
import type { Legacy_Market_list_item } from '../models/Legacy_Market_list_item';
import type { Legacy_Product } from '../models/Legacy_Product';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileAppProxyFallbackService {
    /**
     * výpis hypermarketů
     * Vrací seznam hypermarketů seřezených abacedně
     *
     * @returns any List všch hypermarketů
     * @throws ApiError
     */
    public static getApiHypermarkets({
        legacyApiVersion,
    }: {
        legacyApiVersion: '2_6' | '2_8',
    }): CancelablePromise<{
        status?: number;
        data?: Array<Legacy_Market_list_item>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/{legacyApiVersion}/hypermarkets',
            path: {
                'legacyApiVersion': legacyApiVersion,
            },
        });
    }
    /**
     * detail hypermarketu
     * Detail hypermarketu
     *
     * @returns any
     * @throws ApiError
     */
    public static getApiHypermarkets1({
        legacyApiVersion,
        marketId,
    }: {
        legacyApiVersion: '2_6' | '2_8',
        /**
         * Id hypermarketu
         */
        marketId: number,
    }): CancelablePromise<{
        status?: number;
        data?: Legacy_Market;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/{legacyApiVersion}/hypermarkets/{market_id}',
            path: {
                'legacyApiVersion': legacyApiVersion,
                'market_id': marketId,
            },
        });
    }
    /**
     * akční produkty pro hypermarket
     * Akční produkty pro hypermarket
     *
     * @returns any
     * @throws ApiError
     */
    public static getApiFlyer({
        legacyApiVersion,
        marketId,
    }: {
        legacyApiVersion: '2_6' | '2_8',
        /**
         * Id hypermarketu
         */
        marketId: number,
    }): CancelablePromise<{
        status?: number;
        data?: Array<Legacy_Product>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/{legacyApiVersion}/flyer/{market_id}',
            path: {
                'legacyApiVersion': legacyApiVersion,
                'market_id': marketId,
            },
        });
    }
    /**
     * Datum Poslední změny
     * Poslední změna akčních produktů
     *
     * @returns string Vrací poslední změnu v akčních produktech (Last-Modified)
     * @throws ApiError
     */
    public static headApiFlyer({
        legacyApiVersion,
        marketId,
    }: {
        legacyApiVersion: '2_6' | '2_8',
        /**
         * Id hypermarketu
         */
        marketId: number,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'HEAD',
            url: '/api/{legacyApiVersion}/flyer/{market_id}',
            path: {
                'legacyApiVersion': legacyApiVersion,
                'market_id': marketId,
            },
            responseHeader: 'Last-Modified',
        });
    }
}
